'use strict'

angular.module('shiftTraderApp')
  .service('Reports', function (ServerUrls, TimeService) {
    var baseUrl = ServerUrls.current.railsApi + 'reports/'

    function matchName (name) {
      switch (name) {
        case 'employee-roster':
          return 'employees'
        case 'weekly-hours':
          return 'weekly_hours'
        case 'analyze-days-off':
          return 'analyze_daysoff'
        case 'analyze-trades':
          return 'analyze_trades'
        case 'adp-csv-export':
          return 'adp_csv_export'
        case 'cfa-team-members-export':
          return 'cfa_team_members_export'
        default:
          return ''
      }
    }

    function processInput (input) {
      if (!input) {
        return input
      }
      var proc = lodash.clone(input)
      if (proc.start_date) {
        proc.start_date = TimeService.getBeginningOfDayFromDateWithOrgSetting(input.start_date).toISOString()
      }
      if (proc.end_date) {
        proc.end_date = TimeService.getBeginningOfDayFromDateWithOrgSetting(input.end_date).toISOString()
      }

      return proc
    }



    this.buildReportUrl = function (name, inputs, extraParams) {
      var report_name = matchName(name)
      if (report_name === null) return


      return baseUrl + report_name + '?' + $.param(lodash.merge(processInput(inputs[name]), extraParams))
    }
  })
